import {Component, Output, EventEmitter} from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'app-location-popup',
  templateUrl: '../views/location-popup.component.html',
  styleUrls: ['../styles/basic-info-style.scss']
})
export class LocationPopupComponent  {

    @Output() answerClick = new EventEmitter();

    /** JS-1475: dismissed without saving - the map drops the marker it put on the clicked point. */
    @Output() closed = new EventEmitter();

    public locationName: string;
    public googleLocationName: string;
    public locationId: any;
    public place_id: any;
    public showModal = false;
    public isSubmitted = false;

    /** JS-1475: coordinates already resolved by the map click, if this came from the map. */
    public pendingLat: number = null;
    public pendingLng: number = null;

    constructor() { }


    response(answer: boolean) {
      if (answer)
        this.answerClick.emit(
          {
            id: this.locationId,
            name: this.locationName,
            google_name: this.googleLocationName,
            place_id: this.place_id,
            lat: this.pendingLat,
            lng: this.pendingLng
          });
        this.showModal = answer;

        if (!answer) {
          this.closed.emit();
        }
    }
    onSubmit(form) {
        if (form.valid === true) {
            this.isSubmitted = true;
            this.response(true);
        }
    }
}
